/* eslint-disable react/react-in-jsx-scope */
import { Modal } from '@mui/material';
import { TypePrint } from 'constants/AppEnums';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Language } from 'shared/Language';
import { PopupPrintfAction, PopupPrintfProps } from './types';
import './styles.scss';
import { SVGPrintPayment } from 'pages/payment/popup-payment';

const PopupPrint = forwardRef<PopupPrintfAction, PopupPrintfProps>(({ title, onConfirm }: PopupPrintfProps, ref) => {
    const [type, setType] = useState<Number>(TypePrint.INVOICE);
    const [visible, setVisible] = useState<boolean>(false);

    const showModal = () => {
        setVisible(true);
    };

    const hideModal = () => {
        setVisible(false);
    };

    const renderCheckBox = (types: number, label: string) => {

        const onChooseType = () => {
            setType(types);
        };

        return (
            <div onClick={onChooseType}>
                <div className='bill-item'>
                    {
                        type === types ? (<SVGCheckBox />) : (<SVGUnCheckBox />)
                    }
                    <div style={{ marginLeft: 8 }}>{label}</div>
                </div>
            </div>
        );
    };

    const onConfirmPrintf = () => {
        onConfirm?.(type);
        hideModal();
    };


    useImperativeHandle(ref, () => ({
        showModal,
        hideModal
    }));

    return (
        <Modal open={visible}>
            <div className='modal-print'>
                <div className="popup-print-container">
                    <div className="popup-print-top">
                        <div className="header text-big color-black bold">
                            <SVGPrintPayment />
                            {title}
                        </div>
                        {renderCheckBox(TypePrint.INVOICE, Language.payment.printInvoice)}
                        {renderCheckBox(TypePrint.BILL, Language.payment.print)}
                        {renderCheckBox(TypePrint.BILL_MN, Language.payment.printBillMN)}
                        <div className="button-contain">
                            <div onClick={hideModal} className="button-left">Close</div>
                            <div className="button-right" onClick={onConfirmPrintf}>{Language.common.confirm}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
});
export default PopupPrint;


const SVGCheckBox = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="4" fill="#B98868" />
            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#B98868" />
        </svg>

    );
};

const SVGUnCheckBox = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" />
            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#CBCBCD" />
        </svg>
    );
};
